module.exports = __webpack_public_path__ + "static/media/workload.ab3ed9a3.svg";